import { Info } from 'lucide-react';

// Micro-explicación para el usuario no técnico. Un dueño de PyME no tiene
// departamento de sistemas: si el dato se explica, lo usa. Va junto al dato,
// no en un manual aparte.
export default function NotaExplicativa({ titulo, children }) {
  return (
    <div className="flex gap-2 bg-[var(--color-marca-suave)] border border-[var(--color-marca-borde)] rounded-xl p-3 text-sm text-[var(--color-marca-oscura)]">
      <Info className="h-4 w-4 mt-0.5 shrink-0" />
      <div>
        {titulo && <div className="font-semibold">{titulo}</div>}
        <div className="leading-relaxed">{children}</div>
      </div>
    </div>
  );
}
